import React from 'react';

const ServicesBanner = () =>{
    return (
        <>
        <div className='cadOurServices cadAboutBanner cadContactBanner'>
            <img 
            src="/assets/services-banner.webp"
            alt="cadandrender-services-banner" />
            <div className='container'>
                <div className='cadContactBannerContent'>
                    <h1>OUR SERVICES</h1>
                </div>
            </div>
        </div>
        </>
    );
}

export default ServicesBanner;